//常用网址
<template>
  <div class="website">
    <div class="top" @click="$router.go(-1)">首页 / <span>常用网址</span></div>
    <div class="content">
      <div class="title">常用网址</div>
      <div class="box">
        <div class="item" @click="itemClick(item)" v-for="(item, index) in WebsiteList" :key="index">
          {{ item.title }}
        </div>
      </div>
    </div>
    <div class="content" v-for="(item, index) in cityList" :key="index">
      <div class="title">{{ item.title }}</div>
      <div class="box">
        <div class="item" @click="itemClick(item)">
          {{ item.detail.title }}
        </div>
      </div>
      <div v-for="(itm, inx) in item.detail.list" :key="inx">
        <div class="box">
          <div class="item" @click="itemClick(itm)">
            {{ itm.title }}
          </div>
        </div>
        <div class="box">
          <div class="item" v-for="(m, i) in itm.list" :key="i" @click="itemClick(m)">
            {{ m.title }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { WebsiteList, cityList } from "./data";
export default {
  components: {},
  data() {
    return {
      WebsiteList,
      cityList,
    };
  },
  created() {},
  computed: {},
  methods: {
    itemClick(item) {
      console.log(item);
    }
  },
};
</script>

<style scoped lang="scss">
.website {
  @include contentStyle4;
  @mixin web_itemStyle {
    font-size: 14px;
    height: 56px;
    padding: 0 16px;
    font-size: 14px;
    color: #0062ff;
    display: flex;
    align-items: center;
    cursor: pointer;
  }
  .top {
    color: #666;
    font-size: 16px;
    line-height: 60px;
    cursor: pointer;
    span {
      color: #999;
    }
  }
  .content {
    background: #fff;
    border-radius: $border-radius;
    margin-bottom: 16px;
    .title {
      height: 60px;
      margin: 0 16px;
      border-bottom: 1px solid #eee;
      line-height: 60px;
      font-size: 16px;
      font-weight: 500;
      color: #262626;
    }
    .box {
      display: grid;
      grid-template-columns: repeat(6, 1fr);
      .item {
        @include web_itemStyle;
      }
    }
  }
}
</style>
